import { render, staticRenderFns } from "./AppUpdatePrompt.vue?vue&type=template&id=7e90b1a2&scoped=true&"
import script from "./AppUpdatePrompt.vue?vue&type=script&lang=js&"
export * from "./AppUpdatePrompt.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdatePrompt.vue?vue&type=style&index=0&id=7e90b1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90b1a2",
  null
  
)

export default component.exports